import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PlayIcon, TrendingUpIcon, CheckCircleIcon, SparklesIcon, TargetIcon, ZapIcon, ShieldCheckIcon, UsersIcon, BarChart3Icon, RocketIcon, ArrowRightIcon, StarIcon, BrainIcon, ActivityIcon, NetworkIcon, DatabaseIcon, LineChartIcon, FolderIcon } from 'lucide-react';
export function HomePage() {
  const navigate = useNavigate();
  return <div className="w-full" data-id="element-7322">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-red-900 text-white py-32 overflow-hidden" data-id="element-7323">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-7324" />
        <div className="absolute inset-0" data-id="element-7325">
          <div className="absolute top-20 left-10 w-72 h-72 bg-red-500/20 rounded-full blur-3xl animate-pulse" data-id="element-7326" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-7327" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-7328">
          <div className="max-w-4xl mx-auto text-center" data-id="element-7329">
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-7330">
              One GTM platform that turns signals into revenue
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-7331">
              Connect ZoomInfo data, GTM Studio, Copilot, and Orchestration to
              plan, launch, and measure high velocity go-to-market plays across
              marketing, sales, CS, and partner teams.
            </p>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-7332">
              <button onClick={() => navigate('/demo/upsell')} className="px-8 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7333">
                Start an interactive tour
              </button>
              <Link to="/website/contact" className="px-8 py-4 bg-white text-gray-900 rounded-lg hover:bg-gray-100 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7334">
                Talk to GTM specialist
              </Link>
            </div>
            {/* Support Strip */}
            <div className="flex items-center justify-center gap-8 mt-12" data-id="element-7335">
              <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-7336">
                <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-7337" />
                <span data-id="element-7338">Powered by real ZoomInfo data</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-7339">
                <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-7340" />
                <span data-id="element-7341">Built for AI assisted GTM</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-7342">
                <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-7343" />
                <span data-id="element-7344">Ready for 15+ program portfolios</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why Current Playbook is Breaking */}
      <section className="py-24 bg-white" data-id="element-7345">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7346">
          <div className="text-center mb-16" data-id="element-7347">
            <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-7348">
              Why the current GTM playbook is breaking
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-7349">
              Hybrid buying, too many tools, not enough operators. Plays are
              stuck in decks. Signals arrive but never reach reps. AI is
              guessing.
            </p>
          </div>
          <div className="mb-16" data-id="element-7350">
            <h3 className="text-2xl font-bold text-gray-900 text-center mb-12" data-id="element-7351">
              What the platform does instead:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-7352">
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-6 border border-teal-200" data-id="element-7353">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4" data-id="element-7354">
                  <TargetIcon className="w-6 h-6 text-white" data-id="element-7355" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7356">
                  Studio plans the plays
                </h4>
                <p className="text-sm text-gray-700" data-id="element-7357">
                  Turn ICP, intent, product and CRM signals into a reusable GTM
                  blueprint.
                </p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200" data-id="element-7358">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4" data-id="element-7359">
                  <BrainIcon className="w-6 h-6 text-white" data-id="element-7360" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7361">
                  Copilot runs the plays
                </h4>
                <p className="text-sm text-gray-700" data-id="element-7362">
                  AI tells sellers who to contact and what to say, using that
                  same data.
                </p>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border border-purple-200" data-id="element-7363">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mb-4" data-id="element-7364">
                  <NetworkIcon className="w-6 h-6 text-white" data-id="element-7365" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7366">
                  Orchestration executes across systems
                </h4>
                <p className="text-sm text-gray-700" data-id="element-7367">
                  Marketing, sales engagement, CS, partner.
                </p>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 border border-orange-200" data-id="element-7368">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mb-4" data-id="element-7369">
                  <DatabaseIcon className="w-6 h-6 text-white" data-id="element-7370" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7371">
                  Data, Signals, and Predictive keep it current
                </h4>
                <p className="text-sm text-gray-700" data-id="element-7372">
                  So plays fire at the right time, for the right accounts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What You Can Run on Day 1 */}
      <section className="py-24 bg-gray-50" data-id="element-7373">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7374">
          <div className="text-center mb-16" data-id="element-7375">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7376">
              What you can run on day 1
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-7377">
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7378">
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7379">
                In-market account plays
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7380">
                That move meetings inside 21 days
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7381">
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7382">
                Event to pipeline programs
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7383">That prove event ROI</p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7384">
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7385">
                Leaky funnel recovery
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7386">For stuck opportunities</p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7387">
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7388">
                AI powered expansion
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7389">
                For new ZoomInfo AI products
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7390">
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-7391">
                Partner assisted ABM
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7392">
                For field and channel motions
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-7393">
            <Link to="/gtm/plays" className="inline-flex items-center gap-2 px-8 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium text-lg" data-id="element-7394">
              Explore the GTM library
              <ArrowRightIcon className="w-5 h-5" data-id="element-7395" />
            </Link>
          </div>
        </div>
      </section>
      {/* Platform Highlights */}
      <section className="py-24 bg-white" data-id="element-7396">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7397">
          <div className="text-center mb-16" data-id="element-7398">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7399">
              Platform highlights
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-7400">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 border border-gray-200" data-id="element-7401">
              <div className="w-16 h-16 bg-red-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7402">
                <FolderIcon className="w-8 h-8 text-white" data-id="element-7403" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7404">
                Unified GTM workspace
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7405">
                All teams plan in the same place: Studio. No more one-off
                spreadsheets for campaigns or playbooks.
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 border border-blue-200" data-id="element-7406">
              <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7407">
                <BrainIcon className="w-8 h-8 text-white" data-id="element-7408" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7409">
                Data-first AI
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7410">
                Copilot uses actual ZoomInfo data, buying groups, and account
                activity to generate outreach. Not generic AI text.
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 border border-purple-200" data-id="element-7411">
              <div className="w-16 h-16 bg-purple-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7412">
                <NetworkIcon className="w-8 h-8 text-white" data-id="element-7413" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7414">
                Full funnel orchestration
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7415">
                Visual journeys that move from intent to sales engagement to CS
                and back to Studio.
              </p>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 border border-green-200" data-id="element-7416">
              <div className="w-16 h-16 bg-green-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7417">
                <LineChartIcon className="w-8 h-8 text-white" data-id="element-7418" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7419">
                Operator grade forecasting
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7420">
                Forecast and attainment right in the app, with calculator-style
                modeling, so revenue leaders know the number is real.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* What's New */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white" data-id="element-7421">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7422">
          <div className="text-center mb-16" data-id="element-7423">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7424">
              What's new
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-7425">
            <div className="bg-white rounded-xl p-8 border-2 border-teal-200 hover:shadow-xl transition-all" data-id="element-7426">
              <div className="flex items-center gap-3 mb-4" data-id="element-7427">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center" data-id="element-7428">
                  <TargetIcon className="w-6 h-6 text-white" data-id="element-7429" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7430">GTM Studio</h3>
              </div>
              <p className="text-gray-700" data-id="element-7431">
                Segment, plan, and launch in minutes
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border-2 border-blue-200 hover:shadow-xl transition-all" data-id="element-7432">
              <div className="flex items-center gap-3 mb-4" data-id="element-7433">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-7434">
                  <BrainIcon className="w-6 h-6 text-white" data-id="element-7435" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7436">Copilot</h3>
              </div>
              <p className="text-gray-700" data-id="element-7437">AI guided GTM for sellers and CS</p>
            </div>
            <div className="bg-white rounded-xl p-8 border-2 border-purple-200 hover:shadow-xl transition-all" data-id="element-7438">
              <div className="flex items-center gap-3 mb-4" data-id="element-7439">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-7440">
                  <PlayIcon className="w-6 h-6 text-white" data-id="element-7441" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7442">
                  Plays and Playbooks
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-7443">
                Dynamic library pulled from the app
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border-2 border-green-200 hover:shadow-xl transition-all" data-id="element-7444">
              <div className="flex items-center gap-3 mb-4" data-id="element-7445">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-7446">
                  <RocketIcon className="w-6 h-6 text-white" data-id="element-7447" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7448">Growth plan</h3>
              </div>
              <p className="text-gray-700" data-id="element-7449">
                $999/mo for teams that want Studio + Copilot
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-7450">
            <Link to="/website/platform" className="inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-medium text-lg" data-id="element-7451">
              See what is new
              <ArrowRightIcon className="w-5 h-5" data-id="element-7452" />
            </Link>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-red-600 to-red-700 text-white" data-id="element-7453">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7454">
          <h2 className="text-4xl font-bold mb-6" data-id="element-7455">
            Ready to transform your GTM operations?
          </h2>
          <p className="text-xl text-red-100 mb-8" data-id="element-7456">
            Join leading teams using ZoomInfo GTM Platform with AI
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-7457">
            <Link to="/signup" className="px-8 py-4 bg-white text-red-600 rounded-lg hover:bg-red-50 font-medium text-lg shadow-lg" data-id="element-7458">
              Get Started Free
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7459">
              Schedule Demo
            </Link>
          </div>
        </div>
      </section>
    </div>;
}